import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { TopMessageBox } from 'site-modules/shared/components/inventory/top-message-box/top-message-box';
import { CapOnePrequalApprovedMsg } from 'site-modules/shared/components/inventory/cap-one-prequal-approved-message/cap-one-prequal-approved-message';

export function SrpTopMessage({
  isMobile = false,
  onRemoveCapOnePrequalParam = noop,
  userCapOnePrequalApproved = false,
  onUpdate = noop,
}) {
  if (userCapOnePrequalApproved) {
    return (
      <CapOnePrequalApprovedMsg
        isMobile={isMobile}
        onUpdate={onUpdate}
        onRemoveCapOnePrequalParam={onRemoveCapOnePrequalParam}
      />
    );
  }

  return (
    <TopMessageBox iconClassName="icon-laptop">
      Shopping <b>Nationwide</b> results available for online purchase and local delivery.
    </TopMessageBox>
  );
}

SrpTopMessage.propTypes = {
  inventoryData: PropTypes.shape({
    inventories: PropTypes.shape({
      pageNumber: PropTypes.number,
    }),
    attributes: PropTypes.shape({
      vehicle: PropTypes.shape({
        make: PropTypes.shape({
          name: PropTypes.string,
          niceId: PropTypes.string,
        }),
        model: PropTypes.shape({
          name: PropTypes.string,
        }),
      }),
      radius: PropTypes.number,
      inventoryType: PropTypes.string,
      lowInventoryLeadForm: PropTypes.bool,
    }),
    seoInfo: PropTypes.shape({
      narrativeWidget: PropTypes.shape({
        title: PropTypes.string,
        items: PropTypes.arrayOf(
          PropTypes.shape({
            heading: PropTypes.string,
            content: PropTypes.arrayOf(PropTypes.string),
          })
        ),
        learnMoreText: PropTypes.string,
      }),
    }),
  }),
  isMobile: PropTypes.bool,
  userCapOnePrequalApproved: PropTypes.bool,
  onUpdate: PropTypes.func,
  onRemoveCapOnePrequalParam: PropTypes.func,
};
